import React from 'react';
import { year } from '../../const'
import styles from './footer.module.scss';

function Footer() {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.description}>
          <div className={styles.logo}>Турецкий массаж</div>
          <div>© {year}</div>
        </div>
        <div className={styles.text}>Массаж имеет ряд противопоказаний, перед тем как записаться проконсультируйтесь с доктором.</div>
      </div>
    </div>
  );
}

export default Footer;
